const n = (e, r) => {
  throw new Error(`${JSON.stringify(e)}${r ? ` | ${r}` : ""}`);
};
function o(e, r, { rest: t }) {
  return e == r;
}
export {
  o as exhaustiveEq,
  n as never
};
